import IntegrationListContainer from './container'

export default IntegrationListContainer
